import React from "react"

import Logo from "@static/images/logo.svg"
import LogoTv from "@static/images/logo-tv.svg"
import IconAccount from "@static/images/account.svg"
import IconArrowRight from "@static/images/arrow-right.svg"
import IconArrowRightLarge from "@static/images/arrow-right-large.svg"
import IconCarouselChevronLeft from "@static/images/carousel-chevron-left.svg"
import IconCarouselChevronRight from "@static/images/carousel-chevron-right.svg"
import IconCall from "@static/images/call.svg"
import IconCart from "@static/images/cart.svg"
import IconChainLink from "@static/images/chain-link.svg"
import IconChevronLeft from "@static/images/chevron-left.svg"
import IconChevronRight from "@static/images/chevron-right.svg"
import IconChevronDown from "@static/images/chevron-down.svg"
import IconChevronDownLarge from "@static/images/chevron-down-large.svg"
import IconChevronDownDropdown from "@static/images/chevron-down-dropdown.svg"
import IconClose from "@static/images/close.svg"
import IconCloseLarge from "@static/images/close-large.svg"
import IconCrosshair from "@static/images/crosshair.svg"
import CloseAlt from "@static/images/close-alt.svg"
import IconDots from "@static/images/dots.svg"
import IconEdit from "@static/images/edit.svg"
import IconEyes from "@static/images/eyes.svg"
import IconEyesCurrentColor from "@static/images/eyesCurrentColor.svg"
import IconFacebook from "@static/images/facebook.svg"
import IconFilter from "@static/images/filter.svg"
import IconGift from "@static/images/gift.svg"
import IconHeart from "@static/images/heart.svg"
import IconHeartFaceFilled from "@static/images/heart-face-filled.svg"
import IconHeartFaceUnfilled from "@static/images/heart-face-unfilled.svg"
import IconInstagram from "@static/images/instagram.svg"
import IconLightBulb from "@static/images/light-bulb.svg"
import IconList from "@static/images/list.svg"
import IconLocation from "@static/images/location.svg"
import IconMail from "@static/images/mail.svg"
import IconMessenger from "@static/images/messenger.svg"
import IconMinus from "@static/images/minus.svg"
import IconMinusFaq from "@static/images/minus-faq.svg"
import IconPhone from "@static/images/phone.svg"
import IconPin from "@static/images/pin.svg"
import IconPinterest from "@static/images/pinterest.svg"
import IconPlus from "@static/images/plus.svg"
import IconPlusFaq from "@static/images/plus-faq.svg"
import IconPlusProduct from "@static/images/plus-product.svg"
import IconPressPlay from "@static/images/press-play.svg"
import IconPressPlayArrow from "@static/images/press-play-arrow.svg"
import IconRecording from "@static/images/recording.svg"
import IconSaleBadge from "@static/images/sale-badge.svg"
import IconSearch from "@static/images/search.svg"
import IconSmilingMind from "@static/images/smiling-mind.svg"
import IconSort from "@static/images/sort.svg"
import IconSpaceInvader from "@static/images/space-invader.svg"
import IconSweet from "@static/images/sweet.svg"
import IconTime from "@static/images/time.svg"
import IconTiktok from "@static/images/tiktok.svg"
import IconWavy from "@static/images/wavy.svg"
import IconWavyLong from "@static/images/wavy-long.svg"
import IconWavyExtraLong from "@static/images/wavy-extra-long.svg"
import IconYoutube from "@static/images/youtube.svg"
import IconCloseSmall from "@static/images/close-small.svg"
import IconCloseSmallCircle from "@static/images/close-small-circle.svg"
import MenuIcon from "@static/images/menuIcon.svg"
import Tick from "@static/images/tick.svg"
import IconTick from "@static/images/tick2.svg"
import Grid from "@static/images/grid.svg"
import RoundedBox from "@static/images/roundedBox.svg"
import ChevronRounded from "@static/images/chevronRounded.svg"
import CarouselChevron from "@static/images/carouselChevron.svg"
import CarouselChevronStroke from "@static/images/carousel-chevron-stroke.svg"
import IconStorePin from "@static/images/pin.svg"
import IconSemiCircles from "@static/images/semi-circles.svg"
import IconLimitedEdition from "@static/images/limited-edition.svg"
import IconChocolateDrip from "@static/images/chocolate-drip.svg"
import IconSnoozeville from "@static/images/snoozeville.svg"
import IconTruck from "@static/images/truck.svg"
import IconTruckOutline from "@static/images/truck-outline.svg"
import IconCosmicChoc from "@static/images/cosmic-choc.svg"
import IconChupaChups from "@static/images/chupa-chups.svg"
import IconChupaChupsLayer from "@static/images/chupa-chups-layer.svg"
import Hamburger from "@static/images/hamburger.svg"
import IconChevronRightMenu from "@static/images/chevron-right-menu.svg"
import IconTrash from "@static/images/trash.svg"
import IconEmail from "@static/images/email.svg"
import IconCopy from "@static/images/copy.svg"
import IconDuplicate from "@static/images/duplicate.svg"
import ReviewStarFull from "@static/images/review-star-full.svg"
import ReviewStarEmpty from "@static/images/review-star-empty.svg"
import ReviewStarHalf from "@static/images/review-star-half.svg"
import Tooltip from "@static/images/tooltip.svg"
import Info from "@static/images/info.svg"
import Sparkles from "@static/images/sparkles.svg"
import ShootingStar from "@static/images/shootingStar.svg"
import IconTargetLogo from "@static/images/target-logo.svg"
import IconVideoPause from "@static/images/video-pause.svg"
import IconVideoPlay from "@static/images/video-play.svg"

import { Box, forwardRef, ComponentWithAs, useToken } from "@chakra-ui/react"

export interface IconProps {
  name: string
  title?: string
}

const icons: any = {
  logo: Logo,
  logoTv: LogoTv,
  account: IconAccount,
  arrowRight: IconArrowRight,
  arrowRightLarge: IconArrowRightLarge,
  carouselChevronLeft: IconCarouselChevronLeft,
  carouselChevronRight: IconCarouselChevronRight,
  call: IconCall,
  cart: IconCart,
  chainLink: IconChainLink,
  chevronLeft: IconChevronLeft,
  chevronRight: IconChevronRight,
  chevronRightMenu: IconChevronRightMenu,
  chevronDown: IconChevronDown,
  chevronDownLarge: IconChevronDownLarge,
  chevronDownDropdown: IconChevronDownDropdown,
  closeSmall: IconCloseSmall,
  closeSmallCircle: IconCloseSmallCircle,
  close: IconClose,
  closeAlt: CloseAlt,
  closeLarge: IconCloseLarge,
  crosshair: IconCrosshair,
  dots: IconDots,
  edit: IconEdit,
  eyes: IconEyes,
  eyesCurrentColor: IconEyesCurrentColor,
  facebook: IconFacebook,
  filter: IconFilter,
  gift: IconGift,
  hamburger: Hamburger,
  heart: IconHeart,
  heartFaceFilled: IconHeartFaceFilled,
  heartFaceUnfilled: IconHeartFaceUnfilled,
  instagram: IconInstagram,
  lightBulb: IconLightBulb,
  list: IconList,
  location: IconLocation,
  mail: IconMail,
  messenger: IconMessenger,
  minus: IconMinus,
  minusFaq: IconMinusFaq,
  phone: IconPhone,
  pin: IconPin,
  plus: IconPlus,
  plusFaq: IconPlusFaq,
  plusProduct: IconPlusProduct,
  pressPlay: IconPressPlay,
  pressPlayArrow: IconPressPlayArrow,
  recording: IconRecording,
  saleBadge: IconSaleBadge,
  search: IconSearch,
  smilingMind: IconSmilingMind,
  sort: IconSort,
  spaceInvader: IconSpaceInvader,
  sweet: IconSweet,
  time: IconTime,
  pinterest: IconPinterest,
  tiktok: IconTiktok,
  wavy: IconWavy,
  wavyLong: IconWavyLong,
  wavyExtraLong: IconWavyExtraLong,
  youtube: IconYoutube,
  menuIcon: MenuIcon,
  tick: Tick,
  iconTick: IconTick,
  grid: Grid,
  roundedBox: RoundedBox,
  chevronRounded: ChevronRounded,
  carouselChevron: CarouselChevron,
  carouselChevronStroke: CarouselChevronStroke,
  storePin: IconStorePin,
  semiCircles: IconSemiCircles,
  limitedEdition: IconLimitedEdition,
  chocolateDrip: IconChocolateDrip,
  snoozeville: IconSnoozeville,
  cosmicChoc: IconCosmicChoc,
  chupaChups: IconChupaChups,
  chupaChupsLayer: IconChupaChupsLayer,
  truck: IconTruck,
  truckOutline: IconTruckOutline,
  trash: IconTrash,
  email: IconEmail,
  copy: IconCopy,
  duplicate: IconDuplicate,
  reviewStarFull: ReviewStarFull,
  reviewStarEmpty: ReviewStarEmpty,
  reviewStarHalf: ReviewStarHalf,
  tooltip: Tooltip,
  info: Info,
  sparkles: Sparkles,
  shootingStar: ShootingStar,
  targetLogo: IconTargetLogo,
  videoPause: IconVideoPause,
  videoPlay: IconVideoPlay,
}

const Icon: ComponentWithAs<"div", IconProps> = forwardRef((props, ref) => {
  const { name, title, width = "auto", height = "auto", color, fill, stroke, ...rest } = props as any

  const [resolvedFill] = useToken("colors", [fill])
  const svgFill = fill ? resolvedFill || fill : undefined

  const icon = icons[name]

  return icon ? (
    <Box width={width} height={height} ref={ref} color={color} stroke={stroke} {...rest}>
      <svg
        viewBox={icon.viewBox}
        height="100%"
        width="100%"
        id={icon.id}
        color={color ? "inherit" : undefined}
        fill={svgFill}
        stroke={stroke ? "inherit" : undefined}
      >
        {title && <title>{title}</title>}
        <use xlinkHref={icon.url} />
      </svg>
    </Box>
  ) : (
    <p>[{title || name}]</p>
  )
})
export default React.memo(Icon)
